<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item :label="$t('EXPRESS_COMPANY_CODE')">
      <a-select
              style="width: 100%"
                v-model="form.data.expressCompanyCode"
                @change="handleChange">
        <a-select-option
          v-for="item in expressComanyInfo"
                        :key="item.code"
                        :value="item.code">
          {{ item.name }}
        </a-select-option>
      </a-select>
      <!-- <a-input v-model="form.data.expressCompanyCode" /> -->
    </a-form-model-item>
    <a-form-model-item :label="$t('EXPRESS_NO')">
      <a-input v-model="form.data.expressNo" />
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button
        type="primary"
        v-if="!orderExpressId"
                  @click="onAdd">{{ $t('CREATE') || '创建' }}
        </a-button>
        <a-button
        type="primary"
        v-if="orderExpressId"
                  @click="onUpdate">{{ $t('UPDATE') || '创建' }}
        </a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryOrderExpress,
  _addOrderExpress,
  _updateOrderExpress,
} from '@/api/orderExpressApi';
// import DictSelect from '@/components/DictSelect.vue';

async function getOrderExpress() {
  const result = await _queryOrderExpress(this.orderExpressId);
  if (result) {
    this.form.data.expressNo = result.expressNo;
    this.form.data.expressCompanyCode = result.expressCompanyCode;
    this.form.data.sender = result.sender;
    this.form.data.mobile = result.mobile;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addOrderExpress({
        orderId: this.orderId,
        expressNo: this.form.data.expressNo,
        expressCompanyCode: this.form.data.expressCompanyCode,
        sender: this.form.data.sender,
        mobile: this.form.data.mobile,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      };
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateOrderExpress(this.orderExpressId, {
        orderId: this.orderId,
        expressNo: this.form.data.expressNo,
        expressCompanyCode: this.form.data.expressCompanyCode,
        sender: this.form.data.sender,
        mobile: this.form.data.mobile,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'OrderExpressEdit',
  components: {},
  props: {
    orderExpressId: String,
    orderId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    orderExpressId() {
      if (this.orderExpressId) {
        this.getOrderExpress();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getOrderExpress,
  },
  data() {
    return {
      expressComanyInfo: [
        {
          code: 'dhl',
          name: 'DHL中国件',
        },
        {
          code: 'shunfeng',
          name: '顺丰快递',
        }
      ],
      form: {
        data: {
          expressNo: '',
          expressCompanyCode: 'shunfeng',
          sender: '',
          mobile: '',
        },
        rules: {
          expressNo: [{
            required: true,
            trigger: 'blur',
          }],
          expressCompanyCode: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.orderExpressId) {
      this.getOrderExpress();
    }
  },
};
</script>
